import { Image } from '@rocco/components/image';
import { BASE_STYLE } from './style';
import { cn } from '@rocco/utils/cn';

/**
 * Displays a professional's profile image with fallback handling and proper styling
 */

interface ProfileImageProps {
    profileImageSrc: string;
    name: string;
    width?: number;
    height?: number;
}

export const ProfileImage = (props: ProfileImageProps) => {
    const { profileImageSrc, name, width, height } = props;

    return (
        <div
            className={cn(
                'relative h-full w-full overflow-hidden rounded grayscale',
                BASE_STYLE.TRANSITION_STANDARD
            )}
        >
            <div className="absolute inset-0 h-full w-full">
                <Image
                    src={profileImageSrc}
                    alt={name}
                    width={width || 348}
                    height={height || 485}
                    className="h-full w-full rounded-lg object-cover"
                />
            </div>
        </div>
    );
};
